import { render, staticRenderFns } from "./_base-breadcrumbs.vue?vue&type=template&id=15c3e7d6&scoped=true"
import script from "./_base-breadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-breadcrumbs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-breadcrumbs.vue?vue&type=style&index=0&id=15c3e7d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c3e7d6",
  null
  
)

export default component.exports